import { render, staticRenderFns } from "./safetyHealthyTargetDetailAppr.vue?vue&type=template&id=99bd4980"
import script from "./safetyHealthyTargetDetailAppr.vue?vue&type=script&lang=js"
export * from "./safetyHealthyTargetDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99bd4980')) {
      api.createRecord('99bd4980', component.options)
    } else {
      api.reload('99bd4980', component.options)
    }
    module.hot.accept("./safetyHealthyTargetDetailAppr.vue?vue&type=template&id=99bd4980", function () {
      api.rerender('99bd4980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sai/sht/safetyHealthyTargetDetailAppr.vue"
export default component.exports